import React from 'react';
import Masonry from 'react-masonry-component';

// Masonry options to prevent unnecessary re-renders
const MASONRY_OPTIONS = { transitionDuration: 0 };

const JoybirdMasonryComponentLegacy = ({ photoCardsList }) => (
  <Masonry
    options={MASONRY_OPTIONS}
    enableResizableChildren
    disableImagesLoaded
  >
    {photoCardsList}
  </Masonry>
);

export default JoybirdMasonryComponentLegacy;
